module.exports = __webpack_public_path__ + "static/img/tooth_FDI@2x.8d51fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Trauma/tooth_FDI@2x.png
// module id = ZThz
// module chunks = 2